var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row justify-content-start mr-0 align-items-center"},[_c('div',{staticClass:"label col my-1 d-flex align-items-center"},[_c('p',{staticClass:"empty-category-info"},[_vm._v(" "+_vm._s(_vm.$t('settings.card-settings-options.content-parameters.empty-category'))+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }